import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAppRoles, removeAppRole, setRemoveAppRole } from "../../../../../../redux/AppRole/action";
import { addOption, deleteOption, editOption } from "../../../utils/constant";
import selectors from "../../../../../../redux/AppRole/selectors";
import userManageOperations from '../../../../../../redux/UserManagement/operations'

export const UseAppRoles = (props: any) => {
  const { setSelectedKey, setSelectedRole, selectedRole } = props;
  const option = [editOption];
  const dispatch = useDispatch();
  const GetActiveApplication = userManageOperations.dispatchGetActiveApplication(dispatch)
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);
  const [currentItem, setCurrentItem] = useState({
    roleId: 0,
    roleName: "",
    roleDescription: "",
    applications: null,
    permissions: null,
    selectedApplications: null,
    createdBy: "",
    application: "",
    rownum: 0,
  });
  const [appRoles, setAppRoles] = useState<any>([]);
  const [applicationList, setApplicationList] = useState<any>([]);
  const [selectedApps, setSelectedApps] = useState<any>([]);
  const [appRoleName, setAppRoleName] = useState("");
  const { appRolesData, isAppRemoved, activeApplication } = useSelector((state: any) => ({
    appRolesData: selectors.getAppRoles(state),
    isAppRemoved: selectors.isAppRemoved(state),
    activeApplication: state.UserManagement.activeApplicationData
  }));

  useEffect(() => {
    if (selectedRole) {
      setSelectedRole('');
    }
    dispatch(getAppRoles(selectedApps));
    GetActiveApplication();
  }, []);

  useEffect(() => {
    setAppRoles(appRolesData);
  }, [appRolesData]);

  useEffect(() => {
    if (isAppRemoved) {
      setShowDeleteModal(false);
      setShowInfoModal(true)
      dispatch(setRemoveAppRole(false))
    }
  }, [isAppRemoved])

  const handleInfoModal = () => {
    setShowInfoModal(false);
    setAppRoleName("")
    dispatch(getAppRoles(selectedApps));
  }

  useEffect(() => {
    if (activeApplication.length > 0) {
      const appList = activeApplication?.map((item: any) => {
        return {
          key: item.value,
          text: item.text,
        };
      });
      setApplicationList(appList);
    }
  }, [activeApplication])

  const optionHandler = (evt: any, option: any, selectedRow: any) => {
    if (option.value === deleteOption.value) {
      setShowDeleteModal(true);
      setAppRoleName(selectedRow?.roleName)
    }
    if (option.value === addOption.value) {
      setSelectedKey("add-app-role");
    }
    if (option.value === editOption.value) {
      setSelectedRole(selectedRow)
      setSelectedKey("add-app-role");
    }
    setCurrentItem(selectedRow);
  };
  const handleDeleteModal = () => {
    const roleId = currentItem.roleId;
    dispatch(removeAppRole(roleId));
    setShowDeleteModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  }

  const handleChange = (event: any, value: any) => {
    const updatedApp = value.selected
      ? [...selectedApps, value.key]
      : selectedApps.filter((key: any) => key !== value.key);
    setSelectedApps(updatedApp);
  };

  const handleSubmit = () => {
    const roles = selectedApps;
    dispatch(getAppRoles(roles));
  }

  return {
    showDeleteModal,
    currentItem,
    option,
    handleDeleteModal,
    optionHandler,
    data: appRoles?.data,
    applicationList,
    handleChange,
    selectedApps,
    handleSubmit,
    closeDeleteModal,
    appRoleName,
    handleInfoModal,
    showInfoModal
  };
};
